import { $ } from "js/vendor";

class SVGElement {
    static isSVG() {
        return true;
    }

    get type() {
        return this.constructor.name;
    }

    get layer() {
        return this._layer || 0;
    }

    set layer(value) {
        this._layer = value;
    }

    get canvasBounds() {
        return this.parentElement.canvasBounds;
    }

    constructor(props) {
        this.id = props.id;
        this.parentElement = props.parentElement;
        this.canvas = this.parentElement.canvas;
        this.parentSVG = props.parentSVG;
    }

    create() {
        this._create();
    }

    _create() {

    }

    build(generationKey) {
        this.loadStyles();
        this.generationKey = generationKey;

        this._build();
    }

    _build() {

    }

    render(transition) {
        if (!this.canvas.layouter) return;
        this._render(transition);
        this.applyStyles(this.styles);
    }

    _render(transition) {

    }

    loadStyles() {
        if (this.parentElement.styles.hasOwnProperty(this.id)) {
            this.styles = this.parentElement.styles[this.id];
        }
    }

    applyStyles(styles) {
        this.parentElement.applyStylesToSVG(this.svg, styles, this.options.styleOptions);

        if (styles && styles.shadow) {
            this.svg.filter(add => {
                let blur = add.offset(this.styles.shadow.offsetX || 0, this.styles.shadow.offsetY || 0).in(add.sourceAlpha).gaussianBlur(this.styles.shadow.blur || 10);
                blur = blur.colorMatrix("matrix", [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, this.styles.shadow.opacity || 0.2, 0]);
                add.blend(add.source, blur);
                // this.frame.svg.size('300%', '300%').move('-100%', '-100%');
            });
        } else {
            this.svg.unfilter();
        }
    }

    clipWith(clip) {
        this.svg.clipWith(clip);
    }

    unclip() {
        this.svg.unclip();
    }

    remove() {
        this.svg && this.svg.remove();
    }

    hide() {
        this.svg && this.svg.hide();
    }

    show() {
        this.svg && this.svg.show();
    }
}

class SVGGroupElement extends SVGElement {
    _create() {
        this.svg = this.parentSVG.group();
    }

    _render(transition) {
        let curTransform = $(this.svg.node).transform();
        if (this.position && (this.position.x != curTransform.x || this.position.y != curTransform.y)) {
            this.svg.setPosition(this.position, transition);
        }
    }

    clear() {
        this.svg.clear();
    }
}

class SVGCustomElement extends SVGElement {
    _create() {
        this.svg = this.parentSVG.group();
    }

    _render(transition) {
        let curTransform = $(this.svg.node).transform();
        if (this.position && (this.position.x != curTransform.x || this.position.y != curTransform.y)) {
            this.svg.setPosition(this.position, transition);
        }
    }

    clear() {
        this.svg.clear();
    }
}

class SVGConnectorGroup extends SVGElement {
    _create() {
        this.svg = this.parentSVG.group();
    }

    _render(transition) {
        let curTransform = $(this.svg.node).transform();
        if (this.position && (this.position.x != curTransform.x || this.position.y != curTransform.y)) {
            this.svg.setPosition(this.position, transition);
        }
    }

    clear() {
        this.svg.clear();
    }
}

class SVGPolylineElement extends SVGElement {
    _create() {
        this.svg = this.parentSVG.polyline();
    }

    _render(transition) {
        this.svg.draw(this.path, transition);
        if (this.position) {
            this.svg.setPosition(this.position, transition);
        }
    }
}

class SVGPolygonElement extends SVGElement {
    _create() {
        this.svg = this.parentSVG.polygon();
    }

    _render(transition) {
        this.svg.draw(this.path, transition);
        if (this.position) {
            this.svg.setPosition(this.position, transition);
        }
    }
}

class SVGPathElement extends SVGElement {
    _create() {
        this.svg = this.parentSVG.path();
    }

    _render(transition) {
        // if (!this.currentPath || this.currentPath.split(" ").length != this.path.split(" ").length) {
        //     // set to false transition because svg lib doesn't animate between paths with different lengths - need to check for that state before enabling transition
        //     transition = false;
        // }

        this.svg.draw(this.path, this.forceTransition !== undefined ? this.forceTransition : transition); // this forceTransition flag fixes a bad animation in pie chart wedges where the large sweep flag can't animate between 0 and 1

        this.currentPath = this.path;

        if (this.position) {
            this.svg.setPositionAndScale(this.position.x, this.position.y, this.scale || 1, transition);
        }
    }
}

class SVGRectElement extends SVGElement {
    _create() {
        this.svg = this.parentSVG.rect();
    }

    _render(transition) {
        this.svg.setBounds(this.bounds, transition);
        if (this.position) {
            this.svg.setPosition(this.position, transition);
        }
    }
}

class SVGCircleElement extends SVGElement {
    _create() {
        this.svg = this.parentSVG.circle();
    }

    _render(transition) {
        this.svg.setBounds(this.bounds, transition);
        if (this.position) {
            this.svg.setPosition(this.position, transition);
        }
    }
}

class SVGImageElement extends SVGElement {
    _create() {
        this.svg = this.parentSVG.image();
    }

    _render(transition) {
        this.svg.setBounds(this.bounds, transition);
    }
}

class SVGTextElement extends SVGElement {
    _create() {
        this.svg = this.parentSVG.text("");
    }

    _render(transition) {
        if (this.styles) {
            this.svg.font({
                family: this.styles.font,
                size: this.styles.fontSize
            });
        }

        if (this.position) {
            this.svg.setPosition(this.position, transition);
        }
    }
}

export {
    SVGElement,
    SVGGroupElement,
    SVGCustomElement,
    SVGConnectorGroup,
    SVGImageElement,
    SVGPolylineElement,
    SVGPolygonElement,
    SVGPathElement,
    SVGRectElement,
    SVGCircleElement,
    SVGTextElement
};
